module.exports = __webpack_public_path__ + "static/00014.6a4f755e.jpg";